export const parseCardExpiry = (expiry) => {
    var _a;
    const [monthPart, yearPart] = (_a = expiry.split('/')) !== null && _a !== void 0 ? _a : [];
    const month = +monthPart.trim();
    const year = +yearPart.trim() + 2000;
    return {
        month,
        year,
    };
};
//# sourceMappingURL=parse-card-expiry.js.map